<!-- sidebar-layout.component.html (FULL DROP-IN) -->

<div class="layout" [style.gridTemplateColumns]="gridTemplateColumns" [style.--sidebar-width]="sidebarWidth + 'px'"
  #layout>
  <!-- Single sidebar host (desktop inline + mobile bottom sheet) -->
  <aside #tocSheet id="toc-sheet" class="sidebar" [class.sidebar-inline]="isDesktopView"
    [class.sidebar-sheet]="!isDesktopView" [class.open]="!isDesktopView && isSidebarOpen"
    [attr.role]="isDesktopView ? 'navigation' : 'dialog'" [attr.aria-modal]="isDesktopView ? null : 'true'"
    aria-label="Table of Contents">
    <!-- Sheet header (mobile only; hidden on desktop via CSS) -->
    <div class="sheet-header">
      <div class="sheet-grabber" aria-hidden="true"></div>

      <span class="sheet-title">Table of Contents</span>

      <button #drawerCloseBtn type="button" class="sheet-close" (click)="closeSidebar()" aria-label="Close"
        title="Close">
        ✕
      </button>
    </div>

    <div class="sheet-body">
      <router-outlet name="sidebar"></router-outlet>
    </div>
  </aside>

  <!-- Desktop hint pointing to the TOC sidebar -->
  <div #desktopHint class="toc-desktop-hint" *ngIf="showDesktopTocHint" role="status" aria-live="polite">
    <span class="toc-desktop-hint-text">Pick a topic</span>
  </div>

  <div class="sidebar-handle" (mousedown)="onDragStart($event)" (touchstart)="onDragStart($event)"
    (dblclick)="resetSidebarWidth()" [class.active]="dragging"></div>

  <main class="main-content" #mainScroller (scroll)="onMainScroll(mainScroller)">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- Mobile overlay (only rendered when sheet is open on mobile) -->
<div class="sidebar-overlay" *ngIf="!isDesktopView && isSidebarOpen" (click)="closeSidebar()"></div>

<!-- Mobile trigger (floating pill) -->
<div class="toc-fab-wrap" *ngIf="!isDesktopView">
  <div class="toc-fab-hint" *ngIf="showBrowseHint && !isSidebarOpen" role="status" aria-live="polite">
    <span class="toc-fab-hint-text">Pick a topic</span>
  </div>

  <button #toggleBtn id="toc-open-btn" data-toc-open="1" class="toc-fab" type="button" aria-controls="toc-sheet"
    [attr.aria-expanded]="isSidebarOpen" (click)="toggleSidebar()" title="Browse contents">
    <span class="toc-fab-icon" aria-hidden="true">☰</span>
    <span class="toc-fab-label">Browse</span>
    <span class="toc-fab-caret" aria-hidden="true">▴</span>
  </button>
</div>
